module.exports = __webpack_public_path__ + "static/media/echo2.ab997ae4.jpg";